import { environment } from "src/environments/environment"
import { BankingAccount } from "./BankingAccount.interface"

export const INITIAL_BANKING_ACCOUNT: BankingAccount = (environment.mock && environment.mockBankingAccount) ? {
  inherit: false,
  firstName: "Leia",
  lastName: "Organa",
  iban: "DE02500105170137075030",
  bic: "INGDDEFFXXX",
  authorize: true,
  creditInstitution: "ING"
} : {
  inherit: true,
  firstName: "",
  lastName: "",
  iban: "",
  bic: "",
  authorize: false,
  creditInstitution: ""
}
